import { omit } from 'lodash';
import { useContext } from 'react';
import { authContext } from './authContext';
/**
 * Access auth data (ie user's account)
 */
export const useAuth = () => {
    const val = useContext(authContext);
    if (!val) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    // Throw away items we don't want to export
    const useAuthResult = omit(val, ['setError', 'setErrorSilent']);
    return useAuthResult;
};
